export function wrapFunction<T>(
	baseFn: (this: HTMLElement, e: T) => void,
	extendFn: (e: T) => void
) {
	return function (e: T) {
		extendFn(e);
		baseFn.apply(this, [e]);
	};
}
